import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';
import BlogSection from '../components/BlogSection';
import { blogPosts } from '../data/mock';
import { useLang } from '../context/LanguageContext';

export default function BlogPage() {
  const { t } = useLang();
  return (
    <>
      <Header />
      <PageHeader title={t('page.blog')} breadcrumb={[t('page.crumb.blog')]} />
      <BlogSection limit={blogPosts.length} showHeader={false} />
      <Footer />
    </>
  );
}
